<template>
    <el-dialog
        :visible.sync="dialogVisible"
        width="100vw"
        class="iframe-login-dialog"
        :destroy-on-close="true"
    >  
        <div v-loading="loading" class="iframeBox"></div>
    </el-dialog>
</template>

<script>
import {UserService} from '@digital-supply-chain/module'
import {DomainService} from '@/libs'
import Event, {EventEnum} from '@/EventEmeitter'

export default {
    data() {
        return {
            dialogVisible: false,
            active_key: 'login',
            loading: true,
        }
    },
    mounted() {
        Event.remove(EventEnum.LOGIN_OPEN, this.open);
        Event.on(EventEnum.LOGIN_OPEN, this.open);
        window.removeEventListener('message', this.iframeMessage, false);
    	window.addEventListener('message', this.iframeMessage, false);
    },
    unmounted() {
		window.removeEventListener('message', this.iframeMessage, false);
	},
    methods: {
        open() {
            this.dialogVisible = true;
            this.$nextTick(() => {
              this.init();
            })
        },
        close() {
            this.dialogVisible = false;
        },
        init() {
            const iframeBox = document.querySelector('.iframeBox');
            const iframeEle = document.createElement('iframe');
            iframeEle.width = window.innerWidth;
            iframeEle.height = window.innerHeight;
            iframeEle.setAttribute("frameborder", 0)
            iframeEle.onload = () => {
                this.loading = false;
            }
            iframeEle.src = DomainService.EngineerCommon + '/#/login/0?active_key=' + this.active_key + '&v=' + new Date().getTime();
            iframeBox.appendChild(iframeEle);
        },
        iframeMessage(e) {
			const data = e.data || {};
			const comer = data.comer || "";
			if (comer === 'engineer_login_success') {
                UserService.setUserOfBrowser(data.data || {});
                this.dialogVisible = false;
                window.location.reload();
			}
            if (comer === 'replace_oauth_url') {
                this.close()
            }
		},
    },
}
</script>

<style lang="less" scoped>
    .iframe-login-dialog{
        /deep/ .el-dialog{
            height: 100vh;
            overflow: hidden;
            margin: 0!important;
        }
        /deep/ .el-dialog__header{
            padding: 0;
        }
        /deep/ .el-dialog__body{
            padding: 0;
        }
    }
    .iframeBox{
        width: 100vw;
        height: 100vh;
    }
</style>
